// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1mtID","right":"styles_right__3f1-9"};